/* Wholesale web app caller - wholesale pages only.
   JSONP to the Apps Script web app (window.WS_CONFIG.endpoint) so the browser never hits a CORS
   wall. Every call carries the shared token and the signed-in identity, including, for staff, the
   active client from the picker. Context is cached per active client in sessionStorage so the
   header client name and the notes count paint instantly on each page, then refresh in the
   background. refresh() drops the cache and re-fetches; the notes page uses it after an order
   submit so committed lines leave the working view without a manual reload. Loaded from
   snippets/wholesale-header.liquid before the notes store and the staff picker. */
(function () {
  var CFG = window.WS_CONFIG || {};
  var W = (window.WSApi = window.WSApi || {});
  var seq = 0;

  function call(action, params) {
    return new Promise(function (resolve, reject) {
      if (!CFG.endpoint || !CFG.token) { reject(new Error('WS_CONFIG missing')); return; }
      var cb = '__wscb' + (++seq) + '_' + Date.now();
      var s = document.createElement('script');
      var timer = setTimeout(function () { done(); reject(new Error('timeout')); }, 20000);
      function done() {
        clearTimeout(timer);
        try { delete window[cb]; } catch (e) { window[cb] = undefined; }
        if (s.parentNode) s.parentNode.removeChild(s);
      }
      window[cb] = function (resp) { done(); resolve(resp); };
      var qs = 'action=' + encodeURIComponent(action)
             + '&token=' + encodeURIComponent(CFG.token)
             + '&callback=' + cb
             + '&_=' + Date.now();
      var p = params || {};
      Object.keys(p).forEach(function (k) {
        var v = p[k];
        if (v === undefined || v === null) return;
        if (typeof v === 'object') v = JSON.stringify(v);
        qs += '&' + encodeURIComponent(k) + '=' + encodeURIComponent(v);
      });
      s.onerror = function () { done(); reject(new Error('network')); };
      s.src = CFG.endpoint + '?' + qs;
      document.head.appendChild(s);
    });
  }
  W.call = call;

  W.activeClient = function () { try { return localStorage.getItem('ws_active_client') || ''; } catch (e) { return ''; } };
  W.setActiveClient = function (id) { try { if (id) localStorage.setItem('ws_active_client', id); else localStorage.removeItem('ws_active_client'); } catch (e) {} };

  W.identity = function (extra) {
    var c = CFG.customer || {};
    var base = {
      customer_id: c.id || '',
      email: c.email || '',
      name: c.name || '',
      company: c.company || '',
      is_staff: c.staff ? 'true' : 'false'
    };
    if (c.staff) { var ac = W.activeClient(); if (ac) base.client_id = ac; }
    if (extra) { Object.keys(extra).forEach(function (k) { base[k] = extra[k]; }); }
    return base;
  };

  function cacheKey() { return 'ws_ctx_' + (W.activeClient() || 'self'); }
  W.cached = function () {
    try { var raw = sessionStorage.getItem(cacheKey()); return raw ? JSON.parse(raw) : (W.ctx || null); }
    catch (e) { return W.ctx || null; }
  };

  var ctxPromise = null;
  W.context = function () {
    if (ctxPromise) return ctxPromise;
    try { var raw = sessionStorage.getItem(cacheKey()); if (raw) W.ctx = JSON.parse(raw); } catch (e) {}
    ctxPromise = call('getContext', W.identity()).then(function (resp) {
      var data = (resp && resp.ok) ? resp.data : null;
      if (data) { W.ctx = data; try { sessionStorage.setItem(cacheKey(), JSON.stringify(data)); } catch (e) {} }
      return W.ctx || null;
    }).catch(function () { return W.ctx || null; });
    return ctxPromise;
  };

  /** Drop the memoized context and the sessionStorage cache for the active
   *  client and fetch fresh. Used after writes that change what the page
   *  should show (an order submit commits notes out of the working view). */
  W.refresh = function () {
    ctxPromise = null;
    W.ctx = null;
    try { sessionStorage.removeItem(cacheKey()); } catch (e) {}
    return W.context();
  };

  W.ready = W.context();
})();
